import React, { useState, useEffect } from 'react';
import ModelDetailDropDown from './DropDownStructure'; // Adjust the import path as needed
import { getCategories, getCastingLocations } from '../utils/api'; // Import the API functions for fetching categories and casting locations

const FilterModal = ({ isOpen, closeModal, handleApplyFilters, page, pageSize, currentSort, currentCategories }) => {
  const [selectedSort, setSelectedSort] = useState(currentSort || 'date'); // State for the selected sort option
  const [categories, setCategories] = useState([]); // State for the fetched categories
  const [selectedCategories, setSelectedCategories] = useState(currentCategories); // State for the selected categories
  const [castingLocations, setCastingLocations] = useState([]); // State for the fetched casting locations
  const [selectedCastingLocations, setSelectedCastingLocations] = useState([]); // State for selected casting locations
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchCategories(); // Fetch the categories when the modal is opened
      fetchCastingLocations(); // Fetch casting locations when the modal is opened
    }
  }, [isOpen]);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await getCategories(); // Fetching categories from the API
      setCategories(response.data || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setLoading(false);
    }
  };

  const fetchCastingLocations = async () => {
    try {
      setLoading(true);
      const response = await getCastingLocations(); // Fetching casting locations from the API
      setCastingLocations(response.data || []); // Assuming the API returns an array of locations
      setLoading(false);
    } catch (error) {
      console.error('Error fetching casting locations:', error);
      setLoading(false);
    }
  };

  const handleSortChange = (event) => {
    setSelectedSort(event.target.value); // Update the selected sort option
  };

  const handleCategoryChange = (category) => {
    setSelectedCategories((prev) => {
      if (prev.includes(category)) {
        return prev.filter((item) => item !== category); // Deselect the category
      } else {
        return [...prev, category]; // Select the category
      }
    });
  };

  const handleLocationChange = (location) => {
    setSelectedCastingLocations((prev) => {
      if (prev.includes(location)) {
        return prev.filter((item) => item !== location); // Deselect the location
      } else {
        return [...prev, location]; // Select the location
      }
    });
  };

  const applyFilters = () => {
    console.log('categoriesSelected: ' + selectedCategories);
    handleApplyFilters(selectedSort, selectedCategories, selectedCastingLocations); // Pass selected sort, categories, and locations to the parent component
  };

  if (!isOpen) return null; // Return nothing if the modal is not open

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 className="modal-title">Filters:</h2>
        {/* Accordion: Sort By */}
        <ModelDetailDropDown
          expand={false}
          summary={<p>Sort By</p>}
          details={
            <div>
              <div className="checkbox-option">
                <label>
                  <input
                    type="checkbox"
                    name="sort"
                    value="date"
                    checked={selectedSort === 'date'}
                    onChange={handleSortChange}
                  />
                  Date
                </label>
              </div>
              <div className="checkbox-option">
                <label>
                  <input
                    type="checkbox"
                    name="sort"
                    value="popularity"
                    checked={selectedSort === 'popularity'}
                    onChange={handleSortChange}
                  />
                  Popularity
                </label>
              </div>
            </div>
          }
        />

        {/* Accordion: Categories */}
        <ModelDetailDropDown
          expand={false}
          summary={<p>Categories</p>}
          details={
            loading ? (
              <p>Loading categories...</p>
            ) : (
              <div className='checkbox-list'>
                {/*console.log('categories: ', categories)*/}
                {categories.length > 0 ? (
                  categories.map((category, index) => (
                    <div key={category.category + index} className="checkbox-option">
                      <label>
                        {console.log('category: ', category.category)}
                        <input
                          type="checkbox"
                          value={category.category}
                          checked={selectedCategories.includes(category.category)}
                          onChange={() => handleCategoryChange(category.category)}
                        />
                        {category.category}
                      </label>
                    </div>
                  ))
                ) : (
                  <p>No categories available</p>
                )}
              </div>
            )
          }
        />

        {/* Accordion: Casting Locations */}
        <ModelDetailDropDown
          expand={false}
          summary={<p>Casting Locations</p>}
          details={
            loading ? (
              <p>Loading locations...</p>
            ) : (
              <div className='options-list'>
                {castingLocations.length > 0 ? (
                  castingLocations.map((location) => (
                    <span
                      key={location}
                      className={`category-option ${selectedCastingLocations.includes(location) ? 'selected' : ''}`}
                      onClick={() => handleLocationChange(location)}
                    >
                      {location}
                    </span>
                  ))
                ) : (
                  <p>No locations available</p>
                )}
              </div>
            )
          }
        />

        {/* Cancel and Apply Buttons */}
        <div className="modal-actions">
          <button onClick={closeModal}>Cancel</button>
          <button onClick={applyFilters}>Apply</button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
